module.exports = __webpack_public_path__ + "static/seo-fitness-app-api-4567d009bbf40d20566050a3c8fe2a50.png";